/**
 * Classe permettant de gérer du cache côté client. 
 * Le cache est supprimer lors du repostage de la page.
 */
export class IsiClientCacheManager {
    private static instance: IsiClientCacheManager;
    private readonly cache: Map<string, any>;

    private constructor() {
        this.cache = new Map<string, any>();
    }

    public static getInstance(): IsiClientCacheManager {
        if (!IsiClientCacheManager.instance) {
            IsiClientCacheManager.instance = new IsiClientCacheManager();
        }
        return IsiClientCacheManager.instance;
    }

    public set(key: string, value: any): void {
        this.cache.set(key, value);
    }

    /**
     * Retourne la valeur stocké en cache associé à une clé
     * @param key
     * @returns
     */
    public get<T>(key: string): T | undefined {
        if (!this.has(key)) {
            return undefined
        }
        return this.cache.get(key);
    }

    /**
     * Retourne true si la donnée existe, sinon false
     * @param key
     * @returns
     */
    public has(key: string): boolean {
        return this.cache.has(key);
    }

    /**
     * Supprime les données associés à une clé
     * @param key
     * @returns
     */
    public remove(key: string): void {
        this.cache.delete(key);
    }

    /**
     * Vide toutes les données du cache
     */
    public clear(): void {
        this.cache.clear();
    }
}
